var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1734941615670,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 122466,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M704 0c-176.736 0-320 143.264-320 320 0 20.032 1.856 39.616 5.376 58.624l-389.376 389.376 0 192c0 35.36 28.64 64 64 64l64 0 0-64 128 0 0-128 128 0 0-128 128 0 83.04-83.04c34.016 12.32 70.688 19.04 108.96 19.04 176.736 0 320-143.264 320-320s-143.264-320-320-320zM799.872 320.128c-53.024 0-96-42.976-96-96s42.976-96 96-96 96 42.976 96 96-42.976 96-96 96z",
    fill: "currentColor",
    "p-id": 122467
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.aa2e79d35919686d51573cf8bec92af4.svg";
export { ForwardRef as ReactComponent };